import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-our-services-page',
  templateUrl: './our-services-page.component.html',
  styleUrls: ['./our-services-page.component.scss']
})
export class OurServicesPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
